import React from 'react';

const LocationSection = () => {
  return (
    <section id="location" className="section">
      <div className="location-grid">
        <div className="location-info">
          <h3>Visit Our Showroom</h3>
          <p style={{marginBottom: '30px', color: '#555'}}>
            Experience the cars in person. Our showroom is located in the heart of Puchong Jaya, easily accessible via LDP.
          </p>

          <div className="info-item">
            <div className="info-icon">📍</div>
            <div className="info-text">
              <h4>Address</h4>
              <p>
                No 3 & 5, Jalan Kenari 4,<br />
                Puchong Jaya, 47100 Puchong,<br />
                Selangor Darul Ehsan.
              </p>
              <p>
                <a href="https://maps.app.goo.gl/whFAwyMGS2YjTmUEA" target="_blank" rel="noopener noreferrer" style={{color: 'var(--primary)', fontWeight: '600', textDecoration: 'none', display: 'inline-block', marginTop: '5px'}}>
                  Get Directions (Google Maps)&rarr;
                </a>
              </p>
              <p>
                <a href="https://waze.com/ul/hw28326qj6" target="_blank" rel="noopener noreferrer" style={{color: 'var(--primary)', fontWeight: '600', textDecoration: 'none', display: 'inline-block', marginTop: '5px'}}>
                  Get Directions (Waze)&rarr;
                </a>
              </p>
            </div>
          </div>

          <div className="info-item">
            <div className="info-icon">🕒</div>
            <div className="info-text">
              <h4>Opening Hours</h4>
              <p><strong>Mon - Sat:</strong> 8:30 AM - 8:00 PM</p>
              <p><strong>Sun & Public Holiday:</strong> 10:00 AM - 8:00 PM</p>
            </div>
          </div>

          <div className="info-item">
            <div className="info-icon">📞</div>
            <div className="info-text">
              <h4>Contact</h4>
              <p>Office: 03-5882 8800</p>
              <p>Fax: 03-5882 8802</p>
            </div>
          </div>
        </div>

        <div className="map-frame">
          <iframe 
            src="https://maps.google.com/maps?q=Rangka+Raya+Sdn+Bhd+Puchong&t=&z=15&ie=UTF8&iwloc=&output=embed" 
            allowFullScreen="" 
            loading="lazy" 
            referrerPolicy="no-referrer-when-downgrade"
            title="Location Map"
          >
          </iframe>
        </div>
      </div>
    </section>
  );
};

export default LocationSection;
